import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './views/home/home.component';
import { SellingProductsComponent } from './views/sales-views/selling-products/selling-products.component';
import { TotalSalesComponent } from './views/sales-views/total-sales/total-sales.component';
import { LoginComponent } from './views/login/login.component';
import { AuthGuard } from './helpers/auth.guard';
import { ModuloComponent } from './views/modelo-view/modulo.component';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { SalesGroupComponent } from './views/sales-views/sales-group/sales-group.component';
import { SalesFilialComponent } from './views/sales-views/sales-filial/sales-filial.component';
import { SalesSallersComponent } from './views/sales-views/sales-sallers/sales-sallers.component';
import { PendingConditionalsComponent } from './views/salers-view/pending-conditionals/pending-conditionals.component';
import { SalesRecordDetailComponent } from './views/salers-view/sales-record-detail/sales-record-detail.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'modulo', canActivate: [AuthGuard], component: ModuloComponent },
  { path: 'home/:modulo', canActivate: [AuthGuard], component: HomeComponent },
  {
    path: 'selling-products',
    canActivate: [AuthGuard],
    component: SellingProductsComponent,
  },
  {
    path: 'total-sales',
    canActivate: [AuthGuard],
    component: TotalSalesComponent,
  },
  {
    path: 'sales-group',
    canActivate: [AuthGuard],
    component: SalesGroupComponent,
  },
  {
    path: 'sales-filial',
    canActivate: [AuthGuard],
    component: SalesFilialComponent,
  },
  {
    path: 'sales-sallers',
    canActivate: [AuthGuard],
    component: SalesSallersComponent,
  },
  {
    path: 'pedding-conditionals',
    canActivate: [AuthGuard],
    component: PendingConditionalsComponent,
  },
  {
    path: 'sales-record-detail',
    canActivate: [AuthGuard],
    component: SalesRecordDetailComponent
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'not-found', component: NotFoundComponent },
  { path: '**', redirectTo: 'not-found' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
